import { Center } from '@chakra-ui/react';
import { DotsAnimation } from '../dots-animation/dots-animation';

export const ComingSoon = ({ ...props }) => (
  <Center h="100%" {...props}>
    Coming soon <DotsAnimation />
  </Center>
);
